import styles from "./BackButton.module.scss";
import ArrowBack from "@mui/icons-material/ArrowBack";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

interface Props {
  text: string;
  to?: string | undefined;
}

const BackButton: React.FC<Props> = ({ text, to }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return to ? (
    <Link className={styles.link} to={to}>
      <ArrowBack className={styles.icon} />
      <div className={styles.text}>{t(text)}</div>
    </Link>
  ) : (
    <Link
      className={styles.link}
      onClick={(e) => {
        e.preventDefault();
        navigate(-1);
      }}
      to={".."}
    >
      <ArrowBack className={styles.icon} />
      <div className={styles.text}>{t(text)}</div>
    </Link>
  );
};

export default BackButton;
